import React, { useState } from "react";
import { Layout, Menu, Skeleton, Badge, Drawer, Input } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { size, times, map, intersection, get, filter, concat } from "lodash";
import adminlogo from "assets/InsytLogo.svg";
import _map from "lodash/map";
import logo from "../assets/mglogo.svg";
import COLORS from "common/Colors";
import { MENU } from "common/Constants";
import { useLocation } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import {
  getUserRoleId,
  getLoadingDataFirstTime,
  getUnreadChatMessageList,
  getDepartmentUserList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { DEVICE } from "common/Device";
import { SearchOutlined } from '@ant-design/icons';

const { Item, SubMenu } = Menu;
const StyledLogo = styled.div`
  height: 60px;
  width: 80px;
  margin: 5px 15px 20px;
  text-align: center;
  background: #F3FEFA 0% 0% no-repeat padding-box;
  img {
    margin-top: 5px;
  }
  @media ${DEVICE.tablet} {
    height: 25px;
    margin-bottom: 15px;
    img {
      height: 25px !important;
    }
  }
`;

const StyledInput = styled(Input)`
    background: #F3FEFA 0% 0% no-repeat padding-box;
    border: 0.5px solid #C3C3C3;
    border-radius: 5px;
    opacity: 1;
    width: 80%;
    margin: 0px 20px;
.ant-input {
  background-color: transparent !important;
}
`;

const StyledMenuItem = styled(Item)`
  vertical-align: middle;
  border-radius: 10px;

  &:after {
    border-right: 1px solid
      ${(props) => (props.selected ? `#C2FAE5` : `${COLORS.WHITE}`)} !important;
  }
  &.ant-menu-item-selected {
    background-color: ${(props) =>
    props.selected ? `#C2FAE5` : "inherit"} !important;
    .anticon,
    a,
    svg {
      color: ${(props) =>
    props.selected ? `${COLORS.BLACK}` : `${COLORS.BLACK}`};
      fill: ${(props) =>
    props.selected ? `${COLORS.BLACK}` : `${COLORS.BLACK}`};
    }
  }
  &.ant-menu-item a, .ant-menu-item a:hover, .ant-menu-item a:active {
    color: #000000 !important;
  }
`;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background: #F3FEFA;
    border: none;
  }
  .ant-menu.ant-menu-dark, .ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark .ant-menu-sub {
    color: #000;
      background: #F3FEFA;
  }
  .ant-drawer-close{
    color: #000;
  }
  .ant-menu {
    background: #F3FEFA;
  }
`;

const StyledMenuSkeletonContainer = styled.div`
  text-align: center;
  padding: 10px 20px;
  .ant-skeleton {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const Container = styled.div`
.ant-layout-sider-children{
  background: #F3FEFA 0% 0% no-repeat padding-box;
  margin: 0;
}
.ant-menu{
  font-size: 14px;
  background: #F3FEFA 0% 0% no-repeat padding-box;
  border: none;
  /* margin: 0px 10px 0px 10px; */
}
  overflow-y: auto;
  overflow-x: hidden;
  .sidemenu {
    display: none;
  }
  .hidemenu {
    display: flex;
    width: max-content;
    height: 100%;
    padding: 15px;
    background: #F3FEFA 0% 0% no-repeat padding-box;
    flex-direction: column;
    justify-content: space-between;
    p {
      font-weight: bold;
      padding-left: 5%;
    }
  }
  .hidemenu1 {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: space-between;
    p {
      font-weight: bold;
      padding-left: 5%;
      margin-top: 10%;
    }
  }
  @media ${DEVICE.tablet} {
    .sidemenu {
      width: 150px;
      height: 100vh;
      display: flex;
      justify-content: center;
      position: fixed;
      top: 110px;
      transition: 350ms;
      z-index: 20;
    }
    .hidemenu {
      display: none;
      padding: 10px;
    }
  }
`;

const StyledBadge = styled(Badge)`
  left: 10px;
  top: 4px;
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  .ant-badge-dot {
    width: 10px;
    height: 10px;
    animation: blinker 1s linear infinite;
  }
`;

const { Sider } = Layout;
const SideBar = ({
  defaultKey,
  activePage,
  collapsed,
  setPageTitle,
  userRoleId,
  isLoadingDataFirstTime,
  unreadChatMessageList,
  open,
  onClose,
  departmentUserList,
  userInfo,
  userList,
}) => {
  const menuSkeleton = (key) => (
    <Skeleton.Input block={true} active={true} size="small" key={key} />
  );
  const location = useLocation();

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const filteredDataSource = MENU[5]?.filter((item) =>
    item?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const unreadDot = () => {
    var hrUser = filter(userList, { role_id: 1 });
    if (userRoleId == 2 || userRoleId == 3) {
      let result = map(concat(departmentUserList, hrUser), (e) => e.user_id);
      result = intersection(result, unreadChatMessageList);
      return size(result) ? true : false;
    } else if (userRoleId == 4) {
      let result = map(
        concat(
          filter(userList, {
            department_id: get(userInfo, "staff_department_id", ""),
          }),
          hrUser
        ),
        (e) => e.user_id
      );
      result = intersection(result, unreadChatMessageList);
      return size(result) ? true : false;
    }
    return size(unreadChatMessageList) ? true : false;
  };

  const logoStyle = {
    height: collapsed ? "25px" : "45px",
    marginTop: collapsed ? "0px" : "0px",
  };

  const containerStyle = {
    height: "100vh",
    background: "#F3FEFA",
  };

  const drawerStyle ={
    padding : '0px',
    background: "#F3FEFA",
  }

  const iconStyle={color: "#C3C3C3"}

  return (
    <Container style={containerStyle}>
      <div className="hidemenu">
        <Sider theme="light" trigger={null} collapsible collapsed={collapsed}>
          {userRoleId !== 5 ? (
            <StyledLogo>
              <img style={logoStyle} src={adminlogo} alt="Tymeplus" />
            </StyledLogo>
          ) : (
            <StyledLogo>
              <img style={logoStyle} src={adminlogo} alt="Tymeplus" />
            </StyledLogo>
          )}
          {isLoadingDataFirstTime && (
            <StyledMenuSkeletonContainer>
              {times(10, (ind) => menuSkeleton(ind))}
            </StyledMenuSkeletonContainer>
          )}
          <StyledInput
                className="mb-2"
                value={searchTerm}
                placeholder="Search"
                onChange={handleSearchChange}
                suffix={<SearchOutlined style={iconStyle}/>}
              />
          {!isLoadingDataFirstTime && (
            <Menu
              // theme="dark"
              mode="inline"
              defaultSelectedKeys={[activePage]}
              defaultOpenKeys={[defaultKey]}
            >
              {_map(filteredDataSource, (menu) => {
                return menu?.subMenu && menu?.subMenu?.length > 0 ? (
                  <SubMenu key={menu?.key} icon={menu?.icon} title={menu?.title}>
                    {_map(menu?.subMenu, (submenu) => {
                      return submenu?.subMenu && submenu?.subMenu?.length > 0 ? (
                        <SubMenu
                          key={submenu?.key}
                          icon={submenu?.icon}
                          title={submenu?.title}
                        >
                          {_map(submenu?.subMenu, (submenu) => {
                            return (
                              <StyledMenuItem
                                collapsed={collapsed ? "true" : "false"}
                                key={submenu?.key}
                                icon={submenu?.icon}
                                onClick={() => setPageTitle(submenu?.title)}
                                selected={
                                  location?.pathname.substr(1) == ""
                                    ? false
                                    : true
                                }
                              >
                                <Link to={`/${submenu.path}`}>
                                  {submenu?.title}
                                </Link>
                                <StyledBadge
                                  dot={menu?.path === "team" && unreadDot()}
                                />
                              </StyledMenuItem>
                            );
                          })}
                        </SubMenu>
                      ) : (
                        <StyledMenuItem
                          collapsed={collapsed ? "true" : "false"}
                          key={submenu?.key}
                          icon={submenu?.icon}
                          onClick={() => setPageTitle(submenu?.title)}
                          selected={
                            location?.pathname.substr(1) == "" ? false : true
                          }
                        >
                          <Link to={`/${submenu?.path}`}>{submenu?.title}</Link>
                          <StyledBadge
                            dot={menu?.path === "team" && unreadDot()}
                          />
                        </StyledMenuItem>
                      );
                    })}
                  </SubMenu>
                ) : (
                  <StyledMenuItem
                    key={menu?.key}
                    icon={menu?.icon}
                    onClick={() => setPageTitle(menu?.title)}
                    selected={location?.pathname.substr(1) == "" ? false : true}
                  >
                    <Link to={`/${menu?.path}`}>{menu?.title}</Link>
                    <StyledBadge dot={menu?.path === "team" && unreadDot()} />
                  </StyledMenuItem>
                );
              })}
            </Menu>
          )}
        </Sider>
      </div>
      <div>
        <StyledDrawer
          bodyStyle={drawerStyle}
          width={240}
          title={<img src={adminlogo} width={120} alt="Tymeplus" />}
          placement="left"
          onClose={onClose}
          open={open}
        >
          <Menu
            // theme="dark"
            mode="inline"
            defaultSelectedKeys={[activePage]}
            defaultOpenKeys={[defaultKey]}
          >
            {_map(filteredDataSource, (menu) => {
              return menu?.subMenu && menu?.subMenu?.length > 0 ? (
                <SubMenu key={menu?.key} icon={menu?.icon} title={menu?.title}>
                  {_map(menu?.subMenu, (submenu) => {
                    return submenu?.subMenu && submenu?.subMenu?.length > 0 ? (
                      <SubMenu
                        key={submenu?.key}
                        icon={submenu?.icon}
                        title={submenu?.title}
                      >
                        {_map(submenu?.subMenu, (submenu) => {
                          return (
                            <StyledMenuItem
                              collapsed={collapsed ? "true" : "false"}
                              key={submenu?.key}
                              icon={submenu?.icon}
                              onClick={() => {
                                setPageTitle(submenu?.title);
                                onClose();
                              }}
                              selected={
                                location.pathname.substr(1) == "" ? false : true
                              }
                            >
                              <Link to={`/${submenu.path}`}>
                                {submenu?.title}
                              </Link>
                              <StyledBadge
                                dot={menu?.path === "team" && unreadDot()}
                              />
                            </StyledMenuItem>
                          );
                        })}
                      </SubMenu>
                    ) : (
                      <StyledMenuItem
                        collapsed={collapsed ? "true" : "false"}
                        key={submenu?.key}
                        icon={submenu?.icon}
                        onClick={() => {
                          setPageTitle(submenu?.title);
                          onClose();
                        }}
                        selected={
                          location?.pathname.substr(1) == "" ? false : true
                        }
                      >
                        <Link to={`/${submenu?.path}`}>{submenu?.title}</Link>
                        <StyledBadge
                          dot={menu?.path === "team" && unreadDot()}
                        />
                      </StyledMenuItem>
                    );
                  })}
                </SubMenu>
              ) : (
                <StyledMenuItem
                  key={menu?.key}
                  icon={menu?.icon}
                  onClick={() => {
                    setPageTitle(menu?.title);
                    onClose();
                  }}
                  selected={location?.pathname.substr(1) == "" ? false : true}
                >
                  <Link to={`/${menu?.path}`}>{menu?.title}</Link>
                  <StyledBadge
                    dot={
                      menu?.path === "team" && size(unreadChatMessageList)
                        ? true
                        : false
                    }
                  />
                </StyledMenuItem>
              );
            })}
          </Menu>
        </StyledDrawer>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  isLoadingDataFirstTime: getLoadingDataFirstTime(state),
  unreadChatMessageList: getUnreadChatMessageList(state),
  departmentUserList: getDepartmentUserList(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps, null)(SideBar);
